import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestMovePost = {
    path: "/move",
    method: RouteHttpVerb.POST
};
export { locationRestMovePost };
